import App from '../App.vue'
import router from '../router'
import '../assets/css/main.css'
import 'primeicons/primeicons.css'  // Add PrimeIcons CSS
import axios from 'axios'
import primeInitFactory from '../utils/primeInit'

// Configure axios immediately when the module loads
const setupAxios = () => {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  if (token) {
    axios.defaults.headers.common['X-CSRF-Token'] = token
  }

  // Prioritize window.GROUND_CONTROL_API_KEY since it's set from Rails ENV
  const GROUND_CONTROL_API_KEY = window.GROUND_CONTROL_API_KEY ||
                                 import.meta.env.VITE_GROUND_CONTROL_API_KEY ||
                                 'your-api-key-here'

  console.log('🔍 setupAxios debug:')
  console.log('- window.GROUND_CONTROL_API_KEY:', window.GROUND_CONTROL_API_KEY)
  console.log('- VITE_GROUND_CONTROL_API_KEY:', import.meta.env.VITE_GROUND_CONTROL_API_KEY)
  console.log('- Final GROUND_CONTROL_API_KEY:', GROUND_CONTROL_API_KEY)

  // Which exchange (alldoq core) deployment the console manages. Persisted in
  // localStorage and sent as X-Exchange-Instance on every proxy request.
  // Defaults to core so existing behaviour is unchanged.
  const EXCHANGE_INSTANCES = ['core', 'tula']
  const exchangeInstance = localStorage.getItem('exchangeInstance') || 'core'
  if (EXCHANGE_INSTANCES.includes(exchangeInstance)) {
    axios.defaults.headers.common['X-Exchange-Instance'] = exchangeInstance
  }

  if (GROUND_CONTROL_API_KEY && GROUND_CONTROL_API_KEY !== 'your-api-key-here' && GROUND_CONTROL_API_KEY !== '') {
    axios.defaults.headers.common['Authorization'] = `Bearer ${GROUND_CONTROL_API_KEY}`
    console.log('✅ API Authorization header configured:', axios.defaults.headers.common['Authorization'])
    console.log('✅ axios.defaults.headers.common:', axios.defaults.headers.common)
  } else {
    console.warn('⚠️ GROUND_CONTROL_API_KEY not configured properly. Value:', GROUND_CONTROL_API_KEY)
    console.warn('⚠️ API requests may fail.')
  }
}

// Make axios available globally for debugging
window.axios = axios

// Setup axios immediately
setupAxios()

document.addEventListener('DOMContentLoaded', () => {
  // Re-run axios setup in case window.GROUND_CONTROL_API_KEY was set after initial load
  setupAxios()

  // Create a Vue app instance with PrimeVue
  const { primeInitVue } = primeInitFactory()
  
  // Initialize the app with router and props
  primeInitVue(App, '#app', { router: router })
})